module.exports = __webpack_public_path__ + "static/media/pwa_install_new.58812750.png";